"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sankey_plus_zoom_text_zone = exports.zone_selection_label = exports.sankey_plus_min_width_and_height = exports.dragLabelEventTextEvent = exports.eventLabelClick = exports.SankeyPlusDrawLabels = void 0;
const d3 = __importStar(require("d3"));
const d3_textwrap_1 = require("d3-textwrap");
const SankeyDrawFunction_1 = require("open-sankey/dist/SankeyDrawFunction");
const SankeyPlusNodes_1 = require("./SankeyPlusNodes");
const SankeyPlusDrawLabels = (data, set_data, multi_selected_label, accordion_ref, button_ref, alt_key_pressed, min_width_and_height, multi_selected_nodes, multi_selected_links, link_text, getLinkValue, drawArrows, scale, inv_scale, mode_selection, start_point, closeAllMenuContext) => {
    const add_labels = () => {
        const g_label = d3.select(' .opensankey #svg #g_label');
        const sankeyTooltip = d3.select('div.sankey-tooltip');
        Object.values(data.labels).map(d => {
            const gg_label = g_label.append('g').attr('x', d.x).attr('y', d.y)
                .attr('id', d.idLabel)
                .attr('class', 'gg_label')
                .attr('transform', 'translate(' + d.x + ',' + d.y + ')');
            gg_label.append('rect')
                .attr('width', d.label_width).attr('height', d.label_height)
                .attr('fill', d.color)
                .style('fill-opacity', +(d.opacity / 100))
                .attr('stroke', d.color_border)
                .attr('stroke-opacity', (d.transparent_border && !multi_selected_label.current.includes(d)) ? 0 : 1)
                .attr('stroke-width', ((multi_selected_label.current.includes(d)) ? 3 : 1))
                .attr('rx', 5);
            draw_text_zone_handles(data, d, multi_selected_label, set_data);
            gg_label.on('click', (event) => exports.eventLabelClick(event, d, data, sankeyTooltip, accordion_ref, button_ref, multi_selected_label, set_data, multi_selected_nodes, multi_selected_links));
            gg_label.on('mousedown', () => closeAllMenuContext());
            // Traite les labels qui sont dans des foreignObject
            gg_label.filter(() => {
                return d.isTextHTML;
            }).append('foreignObject')
                .attr('width', d.label_width)
                .attr('height', d.label_height)
                .attr('id', d.idLabel + '_text')
                .append('xhtml:div')
                .attr('class', d.is_edit_raw ? '' : 'ql-editor')
                .html(d.name);
            // Traite les labels qui sont simplementdu text
            const label_text = gg_label.filter(() => {
                return !d.isTextHTML;
            })
                .append('text')
                .attr('id', d.idLabel + '_text')
                .attr('x', pos_zdt_x(d))
                .attr('y', pos_zdt_y(d))
                .style('text-anchor', 'middle')
                .style('font-weight', () => (d.font_weight) ? 'bold' : 'normal')
                .style('font-style', () => (d.font_style) ? 'italic' : 'normal')
                .style('font-size', () => d.font_size + 'px')
                .style('text-transform', () => (d.font_uppercase) ? 'uppercase' : 'none')
                .style('text-align', 'center')
                .style('text-decoration', d.underline ? 'underline' : 'none')
                .text(d.name);
            label_text.call(exports.dragLabelEventTextEvent(alt_key_pressed, d));
            const wrap = d3_textwrap_1.textwrap()
                .bounds({ height: 100, width: d.label_width })
                .method('tspans');
            if (d.position_horiz !== '' && d.position_vert !== '') {
                //Appel wrap seulement si le label n'a pas été drag
                //pour éviter que cela cause quelques probleme de position de label drag
                d3.select(' .opensankey #' + d.idLabel + ' text').call(wrap);
            }
            d3.select(' .opensankey #' + d.idLabel + ' text').select('tspan')
                .attr('dy', () => {
                if ((d.position_vert === 'bottom') && d3.select(' .opensankey #' + d.idLabel + ' text').selectAll('tspan').nodes().length > 0) {
                    const tmp = d3.select(' .opensankey #' + d.idLabel + ' text').selectAll('tspan').nodes().length - 1;
                    return -tmp + 'em';
                }
                else if ((d.position_vert === 'middle') && d3.select(' .opensankey #' + d.idLabel + ' text').selectAll('tspan').nodes().length > 0) {
                    const tmp = d3.select(' .opensankey #' + d.idLabel + ' text').selectAll('tspan').nodes().length - 1;
                    return -tmp / 2 + 'em';
                }
                return 0;
            });
            d3.select(' .opensankey #' + d.idLabel + ' text').selectAll('tspan').attr('dx', 2)
                .attr('x', () => {
                let tmp = 0;
                switch (d.position_horiz) {
                    case 'left':
                        tmp = 0;
                        break;
                    case 'centre':
                        tmp = d.label_width / 2;
                        break;
                    case 'right':
                        tmp = d.label_width;
                        break;
                }
                return tmp;
            })
                .attr('text-anchor', () => {
                let tmp = 'left';
                switch (d.position_horiz) {
                    case 'left':
                        tmp = 'start';
                        break;
                    case 'centre':
                        tmp = 'middle';
                        break;
                    case 'right':
                        tmp = 'end';
                        break;
                }
                return tmp;
            });
            gg_label.call(dragLabelEvent(multi_selected_label, d, data, set_data, min_width_and_height, SankeyDrawFunction_1.drawGrid, multi_selected_nodes, multi_selected_links, link_text, getLinkValue, drawArrows, scale, inv_scale, mode_selection, start_point));
            gg_label.append('rect')
                .attr('id', 'drag_zone_' + d.idLabel)
                .attr('width', d.label_width).attr('height', d.label_height)
                .attr('fill', 'none')
                .style('fill-opacity', 0)
                .attr('stroke', d.color_border)
                .attr('stroke-opacity', 0)
                .attr('stroke-width', (3))
                .attr('rx', 5);
        });
    };
    d3.selectAll(' .opensankey #svg #g_label').remove();
    d3.selectAll(' .opensankey #svg #g_label_handles').remove();
    // Insert la balise qui contient tous les lables libres avant la balise de la légende
    d3.select('.opensankey #svg').insert('g', '#g_nodes').attr('class', 'g_label').attr('id', 'g_label');
    d3.select('.opensankey #svg').append('g').attr('class', 'g_label_handles').attr('id', 'g_label_handles');
    // Ajoute l'event au click sur la zone du dessin qui désélectionne tous les labels libres sélectionné
    d3.select('.opensankey #svg').on('click', evt => {
        if (!evt.ctrlKey && d3.select(evt.srcElement).attr('id') === 'svg') {
            multi_selected_label.current = [];
        }
    });
    add_labels();
};
exports.SankeyPlusDrawLabels = SankeyPlusDrawLabels;
const pos_zdt_x = (d) => {
    switch (d.position_horiz) {
        case 'middle':
            return d.label_width / 2;
        case 'right':
            return d.label_width - 3;
        default:
            return d.x_label;
    }
};
const pos_zdt_y = (d) => {
    switch (d.position_vert) {
        case 'top':
            return d.font_size + 3;
        case 'middle':
            return d.label_height / 2;
        case 'bottom':
            return d.label_height - 3;
        default:
            return d.y_label;
    }
};
// Function triggered when a free label is selected, it add a thicker border ans some pointer events
const eventLabelClick = (event, d, data, sankeyTooltip, accordion_ref, button_ref, multi_selected_label, set_data, multi_selected_nodes, multi_selected_links) => {
    if ((event.ctrlKey || event.metaKey) && !(window.SankeyToolsStatic ? window.SankeyToolsStatic : false)) {
        sankeyTooltip.style('opacity', 0);
        if (button_ref && button_ref.current && accordion_ref && accordion_ref.current === null) {
            button_ref.current.click();
        }
        d3.select('#' + d.idLabel + ' rect').attr('stroke-width', (multi_selected_label.current.includes(d)) ? 3 : 1);
        if (multi_selected_label.current.includes(d)) {
            multi_selected_label.current.splice(multi_selected_label.current.indexOf(d), 1);
        }
        else {
            multi_selected_label.current.push(d);
        }
        multi_selected_label.current.forEach(zdt => {
            d3.select('.opensankey #gg_zdt_handles_' + zdt.idLabel).style('display', null);
        });
        set_data(Object.assign({}, data));
        if (accordion_ref && accordion_ref.current) {
            let index_LL = -1;
            //Loop sur le tableau d'item via un for car les HTMLCollection ressemblent à des tableaux mais n'en sont pas (on peut pas faire de map,filter,join ...)
            for (let i = 0; i < accordion_ref.current.children.length; i++) {
                index_LL = (accordion_ref.current.children[i] === accordion_ref.current.children.namedItem('LL')) ? i : index_LL;
            }
            if (index_LL !== -1) {
                accordion_ref.current.children[index_LL].click();
            }
        }
    }
    else {
        multi_selected_label.current = [];
        multi_selected_nodes.current = [];
        multi_selected_links.current = [];
        set_data(Object.assign({}, data));
    }
};
exports.eventLabelClick = eventLabelClick;
/**
 * Function used to drag the text of free label
 * The 'alt' key need to be pressed and the text of the free label dragged
 *
 * @param {boolean} alt_key_pressed
 * @param {SankeyPlusLabel} d
 * @returns {*}
 */
const dragLabelEventTextEvent = (alt_key_pressed, d) => {
    return d3.drag()
        .subject(Object).on('drag', function (event) {
        if (alt_key_pressed) {
            d.position_vert = '';
            d.position_horiz = '';
            const new_x = event.x, new_y = event.y;
            d3.select(' .opensankey #' + d.idLabel + '_text').attr('x', new_x);
            d3.select(' .opensankey #' + d.idLabel + '_text').attr('y', new_y);
            d.x_label = new_x;
            d.y_label = new_y;
            d3.select(' .opensankey #' + d.idLabel + '_text').selectAll('tspan').attr('x', new_x);
        }
    });
};
exports.dragLabelEventTextEvent = dragLabelEventTextEvent;
// Function used to drag the free label
// To be dragged you need to select the free label
const dragLabelEvent = (multi_selected_label, d, data, set_data, min_width_and_height, drawGrid, multi_selected_nodes, multi_selected_links, link_text, getLinkValue, drawArrows, scale, inv_scale, mode_selection, start_point) => {
    const node_visible = [];
    return (d3.drag()
        .on('start', (evt) => {
        if (multi_selected_label.current.includes(d)) {
            d3.selectAll('.node_shape').nodes().forEach(element => {
                node_visible.push(d3.select(element).attr('id'));
            });
        }
        else if (mode_selection.current === 's' && !evt.ctrlKey) {
            // const pos = d3.pointer(evt)
            const pos = [evt.x, evt.y];
            start_point.current = pos;
            d3.select('#svg').append('g').attr('class', 'selection_zone')
                .append('rect').attr('x', pos[0]).attr('y', pos[1]).attr('width', 2).attr('height', 2).attr('fill', 'none').attr('stroke', 'black').attr('stroke-width', '2px').attr('stroke-dasharray', '5,5');
        }
    })
        .subject(Object).on('drag', function (event) {
        if (mode_selection.current === 's' && d3.selectAll('.selection_zone').nodes().length > 0) {
            // Create change the size of the selection zone according to the mouse
            const pos = [event.x, event.y];
            const new_x = (pos[0] > start_point.current[0]) ? start_point.current[0] : pos[0];
            const new_w = (pos[0] > start_point.current[0]) ? (pos[0] - start_point.current[0]) : start_point.current[0] - pos[0];
            const new_y = (pos[1] > start_point.current[1]) ? start_point.current[1] : pos[1];
            const new_h = (pos[1] > start_point.current[1]) ? (pos[1] - start_point.current[1]) : start_point.current[1] - pos[1];
            d3.select('.selection_zone rect').attr('x', new_x);
            d3.select('.selection_zone rect').attr('y', new_y);
            d3.select('.selection_zone rect').attr('width', Math.abs(new_w));
            d3.select('.selection_zone rect').attr('height', Math.abs(new_h));
        }
        else {
            // Drag zdt
            // Cherche si des element seront hors zone si on les drag 
            // Si c'est le cas, pousse les éléments qui ne sont pas sélectionnés dans la direction opposé
            const out_of_zone_item = SankeyPlusNodes_1.return_out_of_bound_element_plus(d, data, event, multi_selected_nodes, node_visible);
            // Pousse les element non sélectionnés dans la direction opposé
            if (out_of_zone_item.length > 0) {
                SankeyPlusNodes_1.opposing_drag_elements_plus(out_of_zone_item, event, d, data, multi_selected_nodes, multi_selected_label);
            }
            SankeyPlusNodes_1.drag_elements_plus(d, data, event, multi_selected_nodes, multi_selected_label, set_data, multi_selected_links, link_text, min_width_and_height, getLinkValue, drawArrows, scale, inv_scale);
        }
    })
        .on('end', (evt) => {
        if (mode_selection.current === 's' && d3.selectAll('.selection_zone').nodes().length > 0) {
            exports.zone_selection_label(data, multi_selected_label, evt);
            SankeyDrawFunction_1.node_visible_on_svg().forEach((k) => SankeyDrawFunction_1.deselect_visualy_nodes(data.nodes[k]));
            const z_x = Number(d3.select('.selection_zone rect').attr('x'));
            const z_y = Number(d3.select('.selection_zone rect').attr('y'));
            const z_w = Number(d3.select('.selection_zone rect').attr('width'));
            const z_h = Number(d3.select('.selection_zone rect').attr('height'));
            const node_visible = SankeyDrawFunction_1.node_visible_on_svg();
            if (evt.shiftKey) {
                Object.values(data.nodes).filter(n => !multi_selected_nodes.current.includes(n) && node_visible.includes(n.idNode) && n.x >= z_x && n.x <= (z_x + z_w) && n.y >= z_y && n.y <= (z_y + z_h)).forEach(n => multi_selected_nodes.current.push(n));
            }
            else {
                multi_selected_nodes.current = Object.values(data.nodes).filter(n => node_visible.includes(n.idNode) && n.x >= z_x && n.x <= (z_x + z_w) && n.y >= z_y && n.y <= (z_y + z_h));
            }
            multi_selected_nodes.current.forEach(n => SankeyDrawFunction_1.select_visualy_nodes(n));
            multi_selected_links.current.forEach(l => SankeyDrawFunction_1.deselect_visualy_links(l));
            multi_selected_links.current = [];
            start_point.current = [0, 0];
            d3.selectAll('.selection_zone').remove();
            set_data(data);
        }
        else if (multi_selected_label.current.length > 0) {
            set_data(data);
        }
    }));
};
const sankey_plus_min_width_and_height = (data) => {
    let [width, height] = SankeyDrawFunction_1.min_width_and_height(data);
    Object.values(data.labels).forEach(n => {
        height = Math.max(height, n.y + n.label_height);
        width = Math.max(width, (n.x + n.label_width));
    });
    height = height + (data.grid_square_size * 2);
    width = width + (data.grid_square_size * 2);
    return [width, height];
};
exports.sankey_plus_min_width_and_height = sankey_plus_min_width_and_height;
const zone_selection_label = (data, multi_selected_label, evt) => {
    if (d3.selectAll('.selection_zone').nodes().length > 0) {
        const z_x = Number(d3.select('.selection_zone rect').attr('x'));
        const z_y = Number(d3.select('.selection_zone rect').attr('y'));
        const z_w = Number(d3.select('.selection_zone rect').attr('width'));
        const z_h = Number(d3.select('.selection_zone rect').attr('height'));
        if (evt.shiftKey) {
            Object.values(data.labels).filter(n => !multi_selected_label.current.includes(n) && n.x >= z_x && n.x <= (z_x + z_w) && n.y >= z_y && n.y <= (z_y + z_h)).forEach(n => multi_selected_label.current.push(n));
        }
        else {
            multi_selected_label.current = Object.values(data.labels).filter(n => n.x >= z_x && n.x <= (z_x + z_w) && n.y >= z_y && n.y <= (z_y + z_h));
        }
    }
};
exports.zone_selection_label = zone_selection_label;
const draw_text_zone_handles = (data, zdt, multi_selected_label, set_data) => {
    d3.select('.opensankey #g_label_handles').append('g').attr('id', 'gg_zdt_handles_' + zdt.idLabel);
    ['top', 'bottom', 'left', 'right'].forEach(pos => {
        add_zdt_handle(zdt, pos, multi_selected_label, data, set_data);
    });
};
const size_zdt_handle = 10;
const add_zdt_handle = (zdt, pos, multi_selected_label, data, set_data) => {
    var _a, _b;
    // Compute the zoom of the svg so we increase the size of the handles if the svg is de-zoomed
    let svg_k_factor = 1;
    if (d3.select('.opensankey #svg').nodes().length > 0) {
        const transform_svg = (_b = (_a = d3.select('.opensankey #svg')) === null || _a === void 0 ? void 0 : _a.attr('transform')) !== null && _b !== void 0 ? _b : '';
        const scale_svg = (transform_svg) ? +transform_svg.split('scale(')[1].replace(')', '') : 1;
        svg_k_factor = (scale_svg < 1 ? (1 / scale_svg) : 1);
    }
    const gg_zdt = d3.select('.opensankey #gg_zdt_handles_' + zdt.idLabel).style('display', multi_selected_label.current.includes(zdt) ? 'inline' : 'none');
    // Draw the circle with parameter commont to all the handles
    const gg_zdt_h_circle = gg_zdt
        .append('rect')
        .attr('class', 'zdt_handles zdt_handle_' + pos)
        .attr('width', size_zdt_handle * svg_k_factor)
        .attr('height', size_zdt_handle * svg_k_factor)
        .attr('fill', 'black')
        .style('cursor', (pos === 'top' || pos === 'bottom') ? 'ns-resize' : 'ew-resize')
        .call(drag_text_zone_hande(zdt, pos, data, set_data));
    // Position the handle 
    switch (pos) {
        case 'top':
            gg_zdt_h_circle
                .attr('x', zdt.x + zdt.label_width / 2 - (size_zdt_handle / 2))
                .attr('y', zdt.y + 0 - (size_zdt_handle / 2));
            break;
        case 'bottom':
            gg_zdt_h_circle
                .attr('x', zdt.x + zdt.label_width / 2 - (size_zdt_handle / 2))
                .attr('y', zdt.y + zdt.label_height - (size_zdt_handle / 2));
            break;
        case 'left':
            gg_zdt_h_circle
                .attr('x', zdt.x + 0 - (size_zdt_handle / 2))
                .attr('y', zdt.y + zdt.label_height / 2 - (size_zdt_handle / 2));
            break;
        case 'right':
            gg_zdt_h_circle
                .attr('x', zdt.x + zdt.label_width - (size_zdt_handle / 2))
                .attr('y', zdt.y + zdt.label_height / 2 - (size_zdt_handle / 2));
            break;
    }
};
const drag_text_zone_hande = (zdt, pos, data, set_data) => {
    const g_zdt_h = d3.select('.opensankey #gg_zdt_handles_' + zdt.idLabel + ' .zdt_handle_' + pos);
    const text_zone_shape = d3.select('#' + zdt.idLabel + ' rect');
    const g_text_zone = d3.select('#' + zdt.idLabel);
    return d3.drag()
        .subject(Object)
        .on('drag', function (event) {
        // The handles change the width and height of the text_zone
        // The top and left handles also shift the x/y of text zone
        switch (pos) {
            case 'top':
                zdt.label_height -= event.dy;
                zdt.y += event.dy;
                g_text_zone.attr('transform', 'translate(' + zdt.x + ',' + zdt.y + ')');
                g_zdt_h.attr('y', zdt.y - (size_zdt_handle / 2));
                text_zone_shape.attr('height', zdt.label_height);
                // Reposition lateral handles
                d3.select('.opensankey #gg_zdt_handles_' + zdt.idLabel + ' .zdt_handle_left').attr('y', zdt.y + zdt.label_height / 2 - (size_zdt_handle / 2));
                d3.select('.opensankey #gg_zdt_handles_' + zdt.idLabel + ' .zdt_handle_right').attr('y', zdt.y + zdt.label_height / 2 - (size_zdt_handle / 2));
                break;
            case 'bottom':
                zdt.label_height += event.dy;
                g_zdt_h.attr('y', zdt.y + zdt.label_height - (size_zdt_handle / 2));
                text_zone_shape.attr('height', zdt.label_height);
                // Reposition lateral handles
                d3.select('.opensankey #gg_zdt_handles_' + zdt.idLabel + ' .zdt_handle_left').attr('y', zdt.y + zdt.label_height / 2 - (size_zdt_handle / 2));
                d3.select('.opensankey #gg_zdt_handles_' + zdt.idLabel + ' .zdt_handle_right').attr('y', zdt.y + zdt.label_height / 2 - (size_zdt_handle / 2));
                break;
            case 'left':
                zdt.label_width -= event.dx;
                zdt.x += event.dx;
                g_text_zone.attr('transform', 'translate(' + zdt.x + ',' + zdt.y + ')');
                g_zdt_h.attr('x', zdt.x - (size_zdt_handle / 2));
                text_zone_shape.attr('width', zdt.label_width);
                // Reposition vertical handles
                d3.select('.opensankey #gg_zdt_handles_' + zdt.idLabel + ' .zdt_handle_top').attr('x', zdt.x + zdt.label_width / 2 - (size_zdt_handle / 2));
                d3.select('.opensankey #gg_zdt_handles_' + zdt.idLabel + ' .zdt_handle_bottom').attr('x', zdt.x + zdt.label_width / 2 - (size_zdt_handle / 2));
                break;
            case 'right':
                zdt.label_width += event.dx;
                g_zdt_h.attr('x', zdt.x + zdt.label_width - (size_zdt_handle / 2));
                text_zone_shape.attr('width', zdt.label_width);
                // Reposition vertical handles
                d3.select('.opensankey #gg_zdt_handles_' + zdt.idLabel + ' .zdt_handle_top').attr('x', zdt.x + zdt.label_width / 2 - (size_zdt_handle / 2));
                d3.select('.opensankey #gg_zdt_handles_' + zdt.idLabel + ' .zdt_handle_bottom').attr('x', zdt.x + zdt.label_width / 2 - (size_zdt_handle / 2));
                break;
        }
    })
        .on('end', () => set_data(data));
};
const sankey_plus_zoom_text_zone = (evt) => {
    const k_factor = evt.transform.k;
    if (k_factor < 1) {
        d3.selectAll('.opensankey .zdt_handles').attr('r', 10 * (1 / k_factor));
    }
};
exports.sankey_plus_zoom_text_zone = sankey_plus_zoom_text_zone;
